module.exports = __webpack_public_path__ + "static/media/portugues.cda9f427.png";


//////////////////
// WEBPACK FOOTER
// ./src/features/election/components/ChangeLenguage/flags/portugues.png
// module id = 6658
// module chunks = 0